import { useCssVars as _useCssVars, defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-b3f23fa8"), n = n(), _popScopeId(), n);
const _hoisted_1 = { class: "quote_area" };
const _hoisted_2 = { class: "frame" };
const _hoisted_3 = /*#__PURE__*/ _createStaticVNode("<div class=\"box__line box__line--top\" data-v-b3f23fa8></div><div class=\"box__line box__line--right\" data-v-b3f23fa8></div><div class=\"box__line box__line--bottom\" data-v-b3f23fa8></div><div class=\"box__line box__line--left\" data-v-b3f23fa8></div><img class=\"quote_img_top\" src=\"/images/quotes-backgrounds/quote.png\" data-v-b3f23fa8><img class=\"quote_img_bottom\" src=\"/images/quotes-backgrounds/quote2.png\" data-v-b3f23fa8>", 6);
const _hoisted_9 = { class: "quote" };
const _hoisted_10 = ["src"];
import { computed } from 'vue';
import { useCalendarImagesStore } from '../stores/calendarImages';
import { useCalendarSettingsStore } from '../stores/calendarSettings';
import { useRouter } from 'vue-router';
export default /*#__PURE__*/ _defineComponent({
    __name: 'QuoteComponent',
    props: {
        imageIndex: null
    },
    setup(__props) {
        const props = __props;
        _useCssVars(_ctx => ({
            "712b5156": (_unref(calendarSettingsStore).quote.fontSize + 'px'),
            "b6634334": (_unref(calendarSettingsStore).quote.color)
        }));
        const router = useRouter();
        const calendarImagesStore = useCalendarImagesStore();
        const calendarSettingsStore = useCalendarSettingsStore();
        /*
            const sourceFile = computed(()=>{
              if ( calendarImagesStore.calendarImages[props.imageIndex] === undefined ) {
                return 'upload-image.png';
              } else {
                return calendarImagesStore.calendarImages[props.imageIndex];
              }
            });
        */
        calendarSettingsStore.quote.fontFace.fontName = 'Allura';
        calendarSettingsStore.quote.fontSize = 38;
        calendarSettingsStore.quote.color = 'hsl(0% 0% 0% / 1)';
        const computedQuote = computed(() => {
            if (calendarSettingsStore.quote.text === null && calendarSettingsStore.calendarDate) {
                const monthIndex = new Date(calendarSettingsStore.calendarDate).getUTCMonth();
                return calendarSettingsStore.quotes[monthIndex]?.quote || '';
            }
            else {
                return calendarSettingsStore.quote.text;
            }
        });
        const sourceFile = computed(() => {
            if (calendarSettingsStore.quote.image === null && calendarSettingsStore.calendarDate) {
                calendarSettingsStore.updateQuoteBackground();
            }
            return '/images/quotes-backgrounds/' + calendarSettingsStore.quote.image;
        });
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createElementVNode("div", _hoisted_2, [
                    _hoisted_3,
                    _createElementVNode("p", _hoisted_9, _toDisplayString(_unref(computedQuote)), 1)
                ]),
                _createElementVNode("img", {
                    class: "preview",
                    src: _unref(sourceFile)
                }, null, 8, _hoisted_10)
            ]));
        };
    }
});
